import {
  initGlance,
  initLogRocketClient,
  initSegmentClientIfNeeded,
} from "@brexhq/next/src/telemetry/analytics";
import {
  createCompositeAnalytics,
  createSegmentAnalyticsWithDecorations,
  createLogRocketAnalytics,
  createMutinyAnalyticsApi,
  createDatadogAnalytics,
} from "@brexhq/next/src/telemetry/analyticsApi";
import { Winda } from "@brexhq/next/src/utils/Winda";
import { getSegmentDestinationsFromCookies } from "@brexhq/next/src/utils/analytics";
import { defaultEnabledCookiesItems } from "@brexhq/next/src/utils/constants";

export type CompositionRoot = ReturnType<typeof compositionRoot>;

// TODO this has become messy, need to extract factories from here
/**
 * Compose all dependencies here as early in the app as possible
 */
export default function compositionRoot() {
  if (!process.env.SEGMENT_KEY) throw new Error("Missing segment key");

  if (process.env.BREX_ENV !== "production") {
    initGlance();
  }

  const trackingPrefs = getSegmentDestinationsFromCookies();

  const segmentClient = initSegmentClientIfNeeded(
    process.env.SEGMENT_KEY,
    trackingPrefs,
  );

  const logRocketClient = initLogRocketClient();
  const logRocketAnalyticsApi = createLogRocketAnalytics(logRocketClient);

  const segmentAnalyticsApi =
    createSegmentAnalyticsWithDecorations(segmentClient);

  const compositeAnalyticsApi = createCompositeAnalytics({
    isDisabled: () => Winda.isDataDogBot,
    children: [
      segmentAnalyticsApi,
      logRocketAnalyticsApi,
      createMutinyAnalyticsApi(),
      createDatadogAnalytics(),
    ],
  });

  return {
    segmentClient,
    analyticsApi: compositeAnalyticsApi,
    analyticsIntegrations: defaultEnabledCookiesItems,
    logRocketClient,
    branch: process.env.BRANCH,
  };
}

export const app = compositionRoot();
